import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {MatCheckboxChange, MatCheckboxModule}        from "@angular/material/checkbox";
import {KeyValue, NgIf, NgStyle} from "@angular/common";
import { TypeHeaderParameters } from "../preconisation-selfcare/preconisation-selfcare.constants";

@Component({
             selector:        'app-header-selfcare',
             templateUrl:     './header-selfcare.component.html',
             styleUrls:       ['./header-selfcare.component.scss'],
             changeDetection: ChangeDetectionStrategy.OnPush,
             standalone:      true,
             imports: [
               ReactiveFormsModule,
               NgStyle,
               MatCheckboxModule,
               NgIf
             ],
             providers:       []
           })
export class HeaderSelfcareComponent implements OnInit {
  @Input() typeHeaderParameters: TypeHeaderParameters;
  @Output() onChange: EventEmitter<KeyValue<string, boolean>>;

  public formgroup: FormGroup;

  constructor(private _fb: FormBuilder) {
    this.onChange = new EventEmitter<KeyValue<string, boolean>>();
    this.formgroup = this._fb.group({
                                      value: ''
                                    });
  }

  ngOnInit(): void {
    this.formgroup.get('value').setValue(this.typeHeaderParameters.selected);
  }

  change(key: string, event: MatCheckboxChange) {
    this.onChange.next({key, value: event.checked});
  }
}
